import { useEffect } from "react";
import { useGetAppConfig } from "@/queries/config/config.api";

export const useDynamicTitle = () => {
  const { data: appConfig } = useGetAppConfig();

  useEffect(() => {
    // Actualizar el título del documento con el nombre de la institución
    const institutionName = appConfig?.institution_name;

    if (institutionName) {
      // Si tenemos el nombre de la institución, usarlo
      document.title = `${institutionName}`;
    } else {
      // Si no hay configuración, usar el título por defecto
      document.title = "Sistema de Digitalización de Trámites";
    }
  }, [appConfig?.institution_name]);
};
